import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PartnersTableBody } from './PartnersTableBody';

export const PartnersTableBodyWithDnD = ({
  data,
  setData,
  setCurID,
  openArchiveModal,
  openUnarchiveModal,
  cities,
  permissions
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <PartnersTableBody
        data={data}
        setData={setData}
        setCurID={setCurID}
        openArchiveModal={openArchiveModal}
        openUnarchiveModal={openUnarchiveModal}
        cities={cities}
        permissions={permissions}
      />
    </DndProvider>
  );
};

PartnersTableBodyWithDnD.propTypes = {
  data: PropTypes.array,
  setData: PropTypes.func,
  setCurID: PropTypes.func,
  openArchiveModal: PropTypes.func,
  openUnarchiveModal: PropTypes.func,
  cities: PropTypes.array,
  permissions: PropTypes.object
};
